import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link, IndexLink } from 'react-router'
import './style.scss'

class Sidebard extends PureComponent {
  constructor (props) {
    super(props)
  }

  render () {

    //console.log(this.props.location.pathname)
    return (
      <div className='sidebar'>

        <ul className='list-unstyled'>
          <li>
            <Link className='' to={`/jobs`} title='Add' activeClassName='active-nav'>

              <i className="icon-clipboard" />
              Jobs
            </Link>
          </li>

          <li>
            <Link className='' to={`/report`} title='Add' activeClassName='active-nav'>
              <i className='icon-trending-up' />
              Report
            </Link>
          </li>

          <li>
            <Link className='' to={`/calendar`} title='calendar' activeClassName='active-nav'>
              <i className='icon-calendar2' />
              Calendar
            </Link>
          </li>

          <li  className='hidden'>
            <Link className='' to={`/suppliers`} title='Add' activeClassName='active-nav'>
              <i className='glyphicon glyphicon-plus' />
              Suppliers
            </Link>
          </li>

          <li>
            <Link className='' to={`/settings`} title='Add' activeClassName='active-nav'>
              <i className='icon-settings' />
              Settings
            </Link>
          </li>


          {1 === 2 &&
            <span>


            <li>
              <Link to={`/expenses`} title='User Details' activeClassName='active-nav'>
                <i className='glyphicon glyphicon-arrow-down' />
                Expenses
              </Link>
            </li>
            <li>
              <Link to={`/sheet/out/${this.props.sheetId}`} title='User Details' activeClassName='active-nav'>
                <i className='glyphicon glyphicon-arrow-up' />
                Expenses
              </Link>
            </li>
            <li>
              <Link className='' to={`/settings`} title='Add' activeClassName='active-nav'>
                <i className='glyphicon glyphicon-cog' />
                Settings
              </Link>
            </li>
              <li>
                <Link to={`/sheet/in/${this.props.sheetId}`} title='Find' activeClassName='active-nav'>
                  <i className='glyphicon glyphicon-arrow-down' />
                  Invoice
                </Link>
              </li>

              <li>
                <IndexLink to={`/sheet/report/${this.props.sheetId}`} title='Add' activeClassName='active-nav'>
                  <i className='glyphicon glyphicon-signal' />
                  Report
                </IndexLink>
              </li>
            </span>
          }
        </ul>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {}
}

export default connect(mapStateToProps)(Sidebard)



// WEBPACK FOOTER //
// ./src/views/components/Sidebard/index.js